import React from 'react';
import { Card, Col, Container, Row } from 'reactstrap';

// Import Images
import serviceGatewayList from "../../assets/images/gallium/service-gateway-list.jpg";
import createServiceGateway from "../../assets/images/gallium/create-service-gateway.jpg";

import FeatherIcon from 'feather-icons-react/build/FeatherIcon';

const ServiceGateway = () => {
    return (
        <React.Fragment>

            <section className="section pt-4 pb-4 mb-4" id="servicegateway">
                <Container>
                    <Row className="align-items-center gy-4 mb-5">
                        <Col lg={6} className="order-2 order-lg-2">
                            <div className="text-muted">
                                <h5 className="fs-12 text-uppercase text-danger">Service Gateway</h5>
                                <h4 className="mb-3">Powerful Networking</h4>
                                <p className="mb-4 ff-secondary">Service Gateway allows you to expose applications on Virtual Machines from the Hypervisor IP Address. This makes hosting apps on bare metal hosting providers as simple as creating a mapping. </p>

                                <Row>
                                    <Col sm={12}>
                                        <div className="vstack gap-2">
                                            <div className="d-flex">
                                                <div className="flex-shrink-0 me-3">
                                                    <FeatherIcon icon="target" className="icon-dual-danger" />
                                                </div>
                                                <div className="flex-grow-1">
                                                    <h5 className="fs-14 mb-3 mt-2">TCP Port Mapping</h5>
                                                    <p className='text-muted'>Map ports from your Hypervisor IP to any Virtual Machine without the need for additional Routers or configuration. </p>
                                                </div>
                                            </div>
                                            <div className="d-flex">
                                                <div className="flex-shrink-0 me-3">
                                                    <FeatherIcon icon="share-2" className="icon-dual-danger" />
                                                </div>
                                                <div className="flex-grow-1">
                                                    <h5 className="fs-14 mb-3 mt-1">HTTP Router <span className="badge border border-danger text-danger">Coming Soon</span></h5>
                                                    <p className='text-muted'>Route application traffic to your Virtual Machines based on the SNI header, allowing a single IP to host hundreds of Applications.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                    
                                </Row>
                            </div>
                        </Col>

                        <Col lg={6} sm={7} className="col-10 ms-auto order-1 order-lg-1 d-none d-lg-block">
                            <div>
                                <img src={createServiceGateway} alt="" className="img-fluid img-thumbnail mx-auto rounded" style={{maxWidth: "90%"}}/>
                            </div>
                            <Card className="card-bg-fill rounded shadow-lg d-none d-lg-block service-gateway-box">
                                <img className="card-img img-fluid" src={serviceGatewayList} alt="Card cap">
                                </img>
                            </Card>
                        </Col>

                        <Col lg={6} sm={7} className="col-10 mx-auto order-1 order-lg-1 d-block d-lg-none">
                            <div>
                                <img src={createServiceGateway} alt="" className="img-fluid img-thumbnail mx-auto rounded "/>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default ServiceGateway;